module.exports = __webpack_public_path__ + "img/icon7.27d5900e.png";